import { render } from "./VagaDetalheVie.vue?vue&type=template&id=2110e040"
import script from "./VagaDetalheVie.vue?vue&type=script&lang=js"
export * from "./VagaDetalheVie.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__